import Styled from 'styled-components'

export default Styled.div`
table {
    background: #272B4A;
    color: #fff;
    thead, th {
        background: #1B203A;
        color: #fff;
    }

    div.action-container {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        button {
            margin: 0px;
            &.btn-showMore {
                padding: 0px;
            }
        }
        div.action-popup {
            position: absolute;
            background: #1B203A;
            width: 10rem;
            left: 50%;
            transform: translateX(-50%);
            z-index: 999;
            border-radius: 3.29611px;
            button {
                display: block;
                width: 100%;
                cursor: pointer;
                padding: 1em 0px;
                background: transparent;
                border: none;
                font-size: 1rem;
                &.btn-delete {
                    color: ${({ theme }) => theme.error}!important;
                }
            }
        }
    }
}
.ant-table-pagination.ant-pagination {
    margin-right: 3em;
`
